<template>
    <b-sidebar
        id="guide-form-sidebar"
        :visible="isGuideFormSidebarActive"
        bg-variant="white"
        sidebar-class="sidebar-lg"
        shadow
        backdrop
        no-header
        right
        @shown="getData(guideData)"
        @hidden="resetForm"
        @change="(val) => $emit('update:is-guide-form-sidebar-active', val)"
    >
        <template #default="{ hide }">
            <div
                class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
            >
                <h5 class="mb-0">Guide Form</h5>
                <feather-icon
                    class="ml-1 cursor-pointer"
                    icon="XIcon"
                    size="16"
                    @click="hide"
                />
            </div>
            <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
                <b-form
                    class="p-2"
                    @submit.prevent="handleSubmit(onSubmit)"
                    @reset.prevent="resetForm"
                >
                    <b-tabs v-model="tabIndex">
                        <b-tab title="Content">
                            <b-tabs content-class="mt-1" v-if="langs.length > 0">
                                <b-tab
                                    v-for="(lang, key) in langs"
                                    :key="'tab-' + key"
                                    :title="lang.name"
                                >
                                    <validation-provider
                                        #default="validationContext"
                                        :name="'name_' + lang.code"
                                        rules="required"
                                    >
                                        <b-form-group
                                            label="Name"
                                            :label-for="'name_' + lang.code"
                                        >
                                            <b-form-input
                                                :id="'name_' + lang.code"
                                                v-model="Data.title[lang.code]"
                                                autofocus
                                                :state="getValidationState(validationContext)"
                                                trim
                                                :placeholder="'name (' + lang.code + ')'"
                                                @input="changeTitle(lang.code)"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        #default="validationContext"
                                        :name="'short_description_' + lang.code"
                                        rules="min:0"
                                    >
                                        <b-form-group
                                            label="Short Description"
                                            :label-for="'short_description_' + lang.code"
                                        >
                                            <quill-editor
                                                :options="editorOptions"
                                                :id="'short_description_' + lang.code"
                                                v-model="Data.short_description[lang.code]"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        #default="validationContext"
                                        :name="'description_' + lang.code"
                                        rules="min:0"
                                    >
                                        <b-form-group
                                            label="Description"
                                            :label-for="'description_' + lang.code"
                                        >
                                            <quill-editor
                                                :options="editorOptions"
                                                :id="'description_' + lang.code"
                                                v-model="Data.description[lang.code]"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        #default="validationContext"
                                        :name="'slug' + lang.code"
                                        rules="required"
                                    >
                                        <b-form-group
                                            label="Slug"
                                            :label-for="'slug' + lang.code"
                                        >
                                            <b-form-input
                                                :id="'slug' + lang.code"
                                                v-model="Data.slug[lang.code]"
                                                :state="getValidationState(validationContext)"
                                                trim
                                                :placeholder="'Slug (' + lang.code + ')'"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        #default="validationContext"
                                        :name="'address_' + lang.code"
                                        rules="required"
                                    >
                                        <b-form-group
                                            label="Address"
                                            :label-for="'address_' + lang.code"
                                        >
                                            <b-form-input
                                                :id="'address_' + lang.code"
                                                v-model="Data.address[lang.code]"
                                                :state="getValidationState(validationContext)"
                                                trim
                                                :placeholder="'address'"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                </b-tab>
                            </b-tabs>
                            <hr />
                            <validation-provider
                                #default="validationContext"
                                :name="'latitude'"
                                rules="required"
                            >
                                <b-form-group
                                    label="Latitude"
                                    :label-for="'latitude'"
                                >
                                    <b-form-input
                                        :id="'latitude'"
                                        v-model="Data.latitude"
                                        :state="getValidationState(validationContext)"
                                        trim
                                        :placeholder="'latitude'"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                :name="'longitude'"
                                rules="required"
                            >
                                <b-form-group
                                    label="Longitude"
                                    :label-for="'longitude'"
                                >
                                    <b-form-input
                                        :id="'longitude'"
                                        v-model="Data.longitude"
                                        :state="getValidationState(validationContext)"
                                        trim
                                        :placeholder="'longitude'"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                :name="'phone_number'"
                            >
                                <b-form-group
                                    label="Phone Number"
                                    :label-for="'phone_number'"
                                >
                                    <b-form-input
                                        :id="'phone_number'"
                                        v-model="Data.phone_number"
                                        :state="getValidationState(validationContext)"
                                        trim
                                        :placeholder="'phone number'"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                :name="'email'"
                            >
                                <b-form-group
                                    label="Email"
                                    :label-for="'email'"
                                >
                                    <b-form-input
                                        :id="'email'"
                                        v-model="Data.email"
                                        :state="getValidationState(validationContext)"
                                        trim
                                        :placeholder="'email'"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                :name="'line'"
                            >
                                <b-form-group
                                    label="Line"
                                    :label-for="'line'"
                                >
                                    <b-form-input
                                        :id="'line'"
                                        v-model="Data.line"
                                        :state="getValidationState(validationContext)"
                                        trim
                                        :placeholder="'line'"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                :name="'reviews'"
                            >
                                <b-form-group
                                    label="Count Reviews"
                                    :label-for="'reviews'"
                                >
                                    <b-form-input
                                        :id="'reviews'"
                                        v-model="Data.count_review"
                                        :state="getValidationState(validationContext)"
                                        trim
                                        :placeholder="'reviews'"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                name="rating"
                                rules="min:0"
                            >
                                <b-form-group
                                    label="Rating"
                                    label-for="rating"
                                >
                                    <b-form-input
                                        :id="'rating'"
                                        v-model="Data.rating"
                                        :state="getValidationState(validationContext)"
                                        trim
                                        :placeholder="'Rating'"
                                    />
                                    <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                name="category_id"
                                rules="min:0"
                            >
                                <b-form-group label="Category" label-for="category_id">
                                    <v-select
                                        id="category_id"
                                        v-model="Data.guide_category_id"
                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                        label="title"
                                        :reduce="(option) => option.id"
                                        placeholder="category"
                                        :options="catagoriesData.map((g) => ({
                                            title: g.title[currentLocale],
                                            id: g.id
                                        }))"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                :name="'url_embed'"
                            >
                                <b-form-group
                                    label="URL GoogleMap Embed"
                                    :label-for="'url_embed'"
                                >
                                    <b-form-input
                                        :id="'url_embed'"
                                        v-model="Data.url_embed"
                                        :state="getValidationState(validationContext)"
                                        trim
                                        :placeholder="'Url GoogleMap Embed'"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                :name="'url_redirection'"
                            >
                                <b-form-group
                                    label="URL Redirection"
                                    :label-for="'url_redirection'"
                                >
                                    <b-form-input
                                        :id="'url_redirection'"
                                        v-model="Data.redirection"
                                        :state="getValidationState(validationContext)"
                                        trim
                                        :placeholder="'url redirection'"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                name="show_site"
                                rules="min:0"
                            >
                                <b-form-group label="Show To.." label-for="show_site">
                                    <v-select
                                        id="show_site"
                                        v-model="Data.show_site"
                                        multiple
                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                        label="title"
                                        :reduce="(option) => option.id"
                                        :get-option-label="getOptionLabel"
                                        :options="
                                            siteData.map((g) => ({
                                                title: g.name[currentLocale],
                                                id: g.id,
                                            }))
                                        "
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <div>
                                <b-button
                                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                    variant="outline-primary"
                                    class="mr-2"
                                    @click="uploadImage('image')"
                                >
                                    Upload Image
                                </b-button>
                                <file-lists
                                    :is-modal-file-lists-show.sync="isModalFileListsShow"
                                    :uploadType="uploadType"
                                    @refesh="refesh"
                                />
                            </div>
                            <br/>
                            <div>
                                <validation-provider
                                    #default="validationContext"
                                    name="cover_image_id"
                                    rules="required"
                                >
                                    <b-form-group label="Cover Image" label-for="image">
                                        <div id="cover_image_id">
                                            <treeselect 
                                                @input="eventSelected"
                                                v-model="model" 
                                                placeholder="Choose Folder"
                                                :reduce="(option) => option.id"
                                                label="title"
                                                :options="folderOptions"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                noChildrenText
                                            />
                                        </div>
                                        <b-form-invalid-feedback>
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </validation-provider>
    
                                <div>
                                    <b-container align-h="center">
                                        <b-row>
                                            <b-col 
                                                cols="3"
                                                v-for="(image, index) in images"
                                                :key="index"
                                                class="pt-2"
                                            >
                                            <img 
                                                @click="eventSelectedCoverImg(image)"
                                                :src="image.path"
                                                width="300"
                                                height="200"
                                                :class="selectedCoverImage==null
                                                    ? '' 
                                                    : selectedCoverImage.id == image.id
                                                        ? 'selected-img'
                                                        : 'disable-img'
                                                "
                                            >
                                            <br/>
                                        </b-col>
                                        <hr/>
                                        </b-row>
                                    </b-container>
                                    <br/>
                                </div>
                                <div v-if="selectedCoverImage!==null">
                                    <hr/>
                                    <div>Choose Guide Images</div>
                                    <b-container align-h="center">
                                        <b-row>
                                            <b-col 
                                                cols="3"
                                                v-for="(image, index) in images.filter(image => image.id !== selectedCoverImage.id)"
                                                :key="index"
                                                class="pt-2"
                                            >
                                            <img 
                                                @click="eventImgSelected(image)"
                                                :src="image.path"
                                                width="300"
                                                height="200"
                                                :class="selectedImages.some(v => v.id === image.id)? 'selected-img' : ''"
                                            >
                                        </b-col>
                                        <hr/>
                                        </b-row>
                                    </b-container>
                                    <br/>
                                </div>
                            </div>
                            <validation-provider
                                #default="validationContext"
                                name="IsActive"
                                rules="required"
                            >
                                <b-form-group label="Is Active" label-for="IsActive">
                                    <b-form-checkbox
                                        id="isactive"
                                        checked="true"
                                        class="custom-control-success"
                                        v-model="Data.is_active"
                                        switch
                                    />
                                    <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <!-- <repeater-section-form
                                v-if="isGuideFormSidebarActive && guideData"
                                @refesh-list="refeshList"
                                :guide-data="guideData"
                                :guide-input-content-remove.sync="GuideInputContentRemove"
                                :guide-input-content.sync="GuideInputContent"
                            /> -->
                            <repeater-section-form
                                v-if="isGuideFormSidebarActive && guideData"
                                @refesh-list="refeshList"
                                :guide-data="guideData"
                                :guide-input-content-remove.sync="GuideInputContentRemove"
                                :guide-input-content.sync="GuideInputContent"
                            />
                        </b-tab>
                        <b-tab title="Banner" v-if="guideData">
                            <upload-form v-if="tabIndex == 1" :guide-data.sync="guideData" />
                        </b-tab>
                        <b-tab title="SEO">
                            <validation-provider
                                #default="validationContext"
                                name="meta_title"
                                rules="min:0"
                            >
                                <b-form-group label="Meta Title" label-for="meta_title">
                                    <b-form-input
                                        id="meta_title"
                                        v-model="Data.meta_title"
                                        autofocus
                                        :state="getValidationState(validationContext)"
                                        trim
                                        placeholder="Meta Title"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                name="meta_description"
                                rules="min:0"
                                
                            >
                                <b-form-group
                                label="Meta Description"
                                label-for="meta_description"
                                >
                                <b-form-input
                                    id="meta_description"
                                    v-model="Data.meta_description"
                                    autofocus
                                    :state="getValidationState(validationContext)"
                                    trim
                                    placeholder="Meta Description"
                                />

                                <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                name="meta_keywords"
                                rules="min:0"
                            >
                                <b-form-group
                                    label="Meta Keywords"
                                    label-for="meta_keywords"
                                >
                                    <b-form-input
                                        id="meta_keywords"
                                        v-model="Data.meta_keyword"
                                        autofocus
                                        :state="getValidationState(validationContext)"
                                        trim
                                        placeholder="Meta Keywords"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-tab>
                    </b-tabs>
                    <div class="d-flex mt-2">
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="outline-success"
                          class="mr-2"
                          type="submit"
                        >
                          Save
                        </b-button>
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          type="button"
                          variant="outline-danger"
                          @click="hide"
                        >
                          Cancel
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
        </template>
    </b-sidebar>
</template>

<script>
    import { $themeConfig } from '@themeConfig'
    import {
        BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback,
        BButton, BTabs, BTab, BCard, BCardText, BFormRadio, BFormRating, BContainer, BRow, BCol,
    } from "bootstrap-vue";
    import { required, alphaNum, email, password,confirmed } from '@validations'
    import { ValidationProvider, ValidationObserver } from "vee-validate";
    import vSelect from "vue-select";
    import store from "@/store";
    import languagesStoreModule from "@/views/languages/languagesStoreModule";
    import folderStoreModule from "../../files/folderStoreModule"
    import formValidation from "@core/comp-functions/forms/form-validation";
    import Ripple from "vue-ripple-directive";
    import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
    import { useToast } from "vue-toastification/composition";
    import { slugify } from "@/@fake-db/utils";
    import { ref, onUnmounted, onMounted } from "@vue/composition-api";
    // import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { quillEditor } from "vue-quill-editor";
    import "quill/dist/quill.snow.css";
    import "quill/dist/quill.core.css";
    import "quill/dist/quill.bubble.css";
    import UploadForm from "../guide-form/UploadForm.vue";
    import RepeaterSectionForm from "../guide-form/RepeaterSectionForm.vue"
    import guideSectionStoreModule from "../guideSectionStoreModule"
    import guideBlockStoreModule from '../guideBlockStoreModule';
    import FileLists from '../../uploadStorage/FileLists.vue'
    import sitesStoreModule from '../../sites/sitesStoreModule'

    export default {
        components: {
            BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback,
            BButton, BTabs, BTab, BCard, BCardText, vSelect, ValidationProvider, BRow, BCol,
            ValidationObserver, quillEditor, BFormRadio, BFormRating, Treeselect, BContainer,
            UploadForm, RepeaterSectionForm, FileLists,
        },

        directives: {
            Ripple,
        },

        model: {
            prop: "isGuideFormSidebarActive",
            event: "update:is-guide-form-sidebar-active",
        },

        props: {
            isGuideFormSidebarActive: {
                type: Boolean,
                required: true,
            },
            guideData: {
                type: Object,
                required: false,
            },
        },

        computed: {
            currentLocale() {
                return this.$i18n.locale;
            },
            folderOptions(){
                return this.folders.map((folder) => this.formatFolder(folder))
            },
            editorOptions (){
                return $themeConfig.snowOption
            }
        },

        setup(props, { emit }){
            const {  appRef } = $themeConfig.app
            const toast = useToast();
            const catagoriesData = ref([]);
            const folders = ref([])
            const tabIndex = ref(0);
            const langs = ref([]);
            const parent = ref(0);
            const selected = ref("")
            const images = ref([])
            const selectedCoverImage = ref(null)
            const selectedImages = ref([])
            const model = ref(null)
            const isModalFileListsShow = ref(false)
            const uploadType = ref('')
            const siteData = ref([])

            const LANGUAGES_STORE_MODULE_NAME = "app-languages";
            if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule);
            onUnmounted(() => {
            if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGES_STORE_MODULE_NAME);
            });

            const FOLDER_STORE_MODULE_NAME = 'files-folder'
            if (!store.hasModule(FOLDER_STORE_MODULE_NAME)) store.registerModule(FOLDER_STORE_MODULE_NAME, folderStoreModule)
            onUnmounted(() => {
                if (store.hasModule(FOLDER_STORE_MODULE_NAME)) store.unregisterModule(FOLDER_STORE_MODULE_NAME)
            });

            const CONTENT_STORE_MODULE_NAME = 'guide-section';
            if (!store.hasModule(CONTENT_STORE_MODULE_NAME)) store.registerModule(CONTENT_STORE_MODULE_NAME, guideSectionStoreModule)
            onUnmounted(() => {
                if (store.hasModule(CONTENT_STORE_MODULE_NAME)) store.unregisterModule(CONTENT_STORE_MODULE_NAME)
            });

            const BLOCK_STORE_MODULE_NAME = 'section-block';
            if (!store.hasModule(BLOCK_STORE_MODULE_NAME)) store.registerModule(BLOCK_STORE_MODULE_NAME, guideBlockStoreModule)
            onUnmounted(() => {
                if (store.hasModule(BLOCK_STORE_MODULE_NAME)) store.unregisterModule(BLOCK_STORE_MODULE_NAME)
            });

            const SITE_STORE_MODULE_NAME = 'app-sites';
            if (!store.hasModule(SITE_STORE_MODULE_NAME)) store.registerModule(SITE_STORE_MODULE_NAME, sitesStoreModule)
            onUnmounted(() => {
                if (store.hasModule(SITE_STORE_MODULE_NAME)) store.unregisterModule(SITE_STORE_MODULE_NAME)
            });

            const userStorage = JSON.parse(localStorage.getItem('userData'));
            const getLocalSite = JSON.parse(localStorage.getItem('site'))

            store.dispatch('app-guides/getGuideCategories')
                .then(response => {
                    catagoriesData.value = response.data.data
            })

            const blankData = {
                meta_title: '',
                meta_description: '',
                meta_keyword: '',
                slug: {},
                guide_category_id: null,
                rating: null,
                latitude: '',
                longitude: '',
                url_embed:'',
                phone_number: '',
                redirection: '',
                is_active: true,
                ordering_count: 0,
                title: {},
                short_description: {},
                description: {},
                address: {},
                cover_image: [],
                files: [],
                category: {},
                created_by: userStorage.id,
                show_site: [],
                email: '',
                line: '',
                count_review: null,
            };

            const Data = ref(blankData);
            const GuideInputContentRemove = ref([])
            const GuideInputContent = ref([])

            const resetData = () => {
                Data.value = blankData;
            };

            const uploadImage = (type) => {
                uploadType.value = type
                isModalFileListsShow.value = true
            }

            const refesh = () => {
                store.dispatch('files-folder/getFolders', {
                    parent: parent.value,
                    order_by:'ordering_count ASC'
                })
                    .then(response => {
                        const res = response.data.data
                        folders.value = res
                })

                model.value = null
                images.value = []
                selectedCoverImage.value = null
                selectedImages.value = []
            }

            const getData = async (data) => {
                tabIndex.value = 0;

                store.dispatch('files-folder/getFolders', {
                    parent: parent.value,
                    order_by:'ordering_count ASC'
                })
                    .then(response => {
                        const res = response.data.data
                        folders.value = res
                })

                model.value = null
                images.value = []
                selectedCoverImage.value = null
                selectedImages.value = []

                Data.value.title = {}
                Data.value.short_description = {}
                Data.value.description = {}
                Data.value.address = {}
                Data.value.slug = {}
                Data.value.guide_category_id = null
                Data.value.rating = null
                Data.value.latitude = ''
                Data.value.longitude = ''
                Data.value.url_embed = ''
                
                Data.value.phone_number = ''
                Data.value.redirection = ''
                Data.value.price = ''
                Data.value.category = 0
                Data.value.allergies = []
                Data.value.category = {},
                Data.value.is_active = true
                Data.value.meta_title = ''
                Data.value.meta_description = ''
                Data.value.meta_keyword = ''
                Data.value.show_site = []
                Data.value.email = ''
                Data.value.line = ''
                Data.value.count_review = null

                if(data) {
                    data.is_active = data.is_active? true: false

                    Data.value = {
                        ...data,
                        show_site: Array.isArray(data.show_site)
                            ? data.show_site.map((g) => (g.site_id))
                            : [],
                    }

                    const files = data.files
                    const folderId = files[0].folder_id
                    
                    await store.dispatch('files-folder/getFolderById', folderId)
                        .then(response => {
                            const res = response.data.data
                            images.value = res[0].images

                            const files = data.files
                            model.value = folderId
                            for(const file of files){
                                if(file.is_feature){
                                    selectedCoverImage.value = file
                                } else {
                                    selectedImages.value.push(file)
                                }
                            }
                        }
                    )

                    if(data.content.length){
                        GuideInputContent.value = data.content
                    } else {
                        GuideInputContent.value = []
                    }
                }
            }

            const changeTitle  = (lang) => {
                if(lang){
                    Data.value.slug[lang] = slugify(Data.value.title[lang]);
                }
            }

            const eventSelected = (id) => {
                store.dispatch('files-folder/getFolderById', id)
                .then(response => {
                    const res = response.data.data
                    images.value = res[0].images

                    const existingFolderId = Data?.value?.files[0]?.folder_id

                    if(model.value != existingFolderId){
                        selectedCoverImage.value = null
                        selectedImages.value = []
                    }
                })
            }

            const eventSelectedCoverImg = (data) => {
                const coverImg = selectedCoverImage.value
                if(coverImg==null){
                    selectedCoverImage.value = data
                    return
                }

                if(coverImg?.id == data.id){
                    selectedCoverImage.value = null
                    return
                }
            }

            const eventImgSelected = (data) => {
                const index = selectedImages.value.findIndex(item => item.id === data.id);
                index === -1 ? selectedImages.value.push(data) : selectedImages.value.splice(index, 1);
            }

            const onSubmit = function () {
                Data.value.is_active = Data.value.is_active?1:0;

                if (GuideInputContentRemove.value.length > 0) {
                    Data.value.content_remove = JSON.stringify(
                        GuideInputContentRemove.value
                    );
                }

                if (GuideInputContent.value.length > 0) {
                    Data.value.content = GuideInputContent.value
                    for (const [key, value] of Object.entries(GuideInputContent.value)) {
                        GuideInputContent.value[key].title_lang = JSON.stringify(value.title);
                    }
                    Data.value.content = JSON.stringify(GuideInputContent.value);
                }

                if(!Data.value.id){
                    Data.value.cover_image = selectedCoverImage.value
                    Data.value.files = selectedImages.value

                    store.dispatch('app-guides/addGuide', Data.value)
                    .then((res) => {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `Success`,
                                icon: 'BellIcon',
                                variant: 'success',
                                text: `${res.data.message}`,
                            },
                        });

                        emit('refetch-data')
                        emit('update:is-guide-form-sidebar-active', false)
                    })
                    .catch((error) => {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: "Error",
                                icon: 'AlertTriangleIcon',
                                variant: 'danger',
                                text: `${error?.response?.data?.message??'Something went wrong'}`,
                            },
                        })
                    })
                } else {
                    Data.value.cover_image = selectedCoverImage.value
                    Data.value.files = selectedImages.value

                    store.dispatch('app-guides/updateGuide', Data.value)
                    .then((res) => {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `Success`,
                                icon: 'BellIcon',
                                variant: 'success',
                                text: `${res.data.message}`,
                            },
                        });

                        Data.value.cover_image = null
                        Data.value.files = []
                        emit('refetch-data')
                        emit('update:is-guide-form-sidebar-active', false)
                    })
                    .catch((error) => {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: "Error",
                                icon: 'AlertTriangleIcon',
                                variant: 'danger',
                                text: `${error?.response?.data?.message??'Something went wrong'}`,
                            },
                        })
                    })
                }
            }

            const refeshList = async () => {
                emit("refetch-data");
            };

            const getLangs = (filter) => {
                store.dispatch("app-languages/fetchData", filter).then((res) => {
                    if (res.data.success) {
                        langs.value = res.data.data;
                    }
                });
            };

            let filter = {
                is_active:1,
                
            }

            onMounted(() => {
                store.dispatch("app-sites/fetchSites", {
                    order_by: 'ordering_count ASC'
                }).then((res) => {
                    const data = res.data.data
                    siteData.value = data
                });
            })

            const {
                resetForm,
                getValidationState,
                refFormObserver
            } = formValidation(resetData);

            getLangs(filter);

            return {
                langs,
                resetForm,
                getData,
                tabIndex,
                Data,
                getValidationState,
                refFormObserver,
                onSubmit,
                changeTitle,
                resetData,
                folders,
                images,
                eventSelected,
                catagoriesData,
                selectedCoverImage,
                eventSelectedCoverImg,
                model,
                eventImgSelected,
                selectedImages,
                refeshList,
                GuideInputContentRemove,
                GuideInputContent,
                uploadImage,
                isModalFileListsShow,
                uploadType,
                refesh,
                siteData,
            }
        },
        methods:{
            formatFolder(folder){
                return{
                    id: folder.id,
                    label: folder.title,
                    children: folder.subFolders.length? folder.subFolders.map(this.formatFolder): undefined
                }
            },
            getOptionLabel(option) {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = option.title;
                return tempDiv.textContent || tempDiv.innerText || "";
            },
        }
    }
</script>

<style lang="scss">
    @import "@core/scss/vue/libs/quill.scss";

    .selected-img{
        border: solid 5px #FFB341;
    }

    .disable-img{
        cursor: not-allowed;
        opacity: 0.5;
    }
</style>